<template>
    <Layout title="Podcasts" :content-class="'content--narrow'">
        <div
            style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 1em;"
        >
            <h1 class="content__title">{{ $t('podcasts.title') }}</h1>
            <router-link to="/podcasts/create" class="button button--medium" type="button">
                {{ $t('podcasts.create') }}
            </router-link>
        </div>
        <Spinner v-if="loading" class="spinner--gray" />
        <div class="podcasts-list">
            <!-- <SearchInput
                v-if="podcasts.length || searchString"
                class="podcasts-list__search"
                :placeholder="$t('podcasts.detail.name')"
                @change="onSearch"
            /> -->

            <template v-if="podcasts.length || loading">
                <transition-group name="fade" appear>
                    <PodcastCard
                        v-for="podcast in podcasts"
                        :key="podcast.id"
                        class="podcasts-list__podcast"
                        :podcast="podcast"
                        @deleted="handleDelete"
                    />
                </transition-group>
                <div v-if="canLoadMore" class="podcasts-list__loadmore">
                    <button
                        type="button"
                        class="button button--medium"
                        :disabled="loading"
                        @click="loadMore"
                    >
                        {{ $t('misc.loadmore') }}
                    </button>
                </div>
            </template>
            <div v-else-if="!loading && !podcasts.length" class="podcasts-list__empty">
                {{ $t('podcasts.list.empty') }}
                <router-link to="/podcasts/create" class="link">
                    {{ $t('podcasts.list.createOne') }}
                </router-link>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import { SearchInput } from '@speechki-frontend/shared/ui/forms';

import PodcastCard from '../../components/PodcastCard/PodcastCard';

export default {
    name: 'PodcastsPage',
    components: {
        Layout,
        SearchInput,
        PodcastCard
    },
    data() {
        return {
            podcasts: [],
            count: 0,
            page: 1,
            pageSize: 10,
            loading: false,
            searchString: ''
        };
    },
    computed: {
        canLoadMore() {
            return this.page * this.pageSize < this.count;
        }
    },
    created() {
        this.fetchPodcasts();
    },
    methods: {
        async fetchPodcasts() {
            try {
                this.loading = true;

                const params = {
                    page: this.page,
                    page_size: this.pageSize,
                    ordering: '-id'
                };

                if (this.searchString) {
                    params.search = this.searchString;
                }

                const { results, count } = await this.$http.get('/api/v1/podcast/podcasts/', {
                    params
                });

                if (this.page === 1) {
                    this.podcasts = results;
                    this.count = count;
                } else {
                    this.podcasts = [...this.podcasts, ...results];
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        loadMore() {
            this.page = this.page + 1;
            this.fetchPodcasts();
        },
        onSearch(searchString) {
            this.page = 1;
            this.searchString = searchString;
            this.fetchPodcasts();
        },
        handleDelete(podcast) {
            const target = this.podcasts.findIndex(p => p.id === podcast.id);

            this.podcasts.splice(target, 1);
        }
    }
};
</script>

<style lang="scss" src="./PodcastsPage.scss"></style>
